@if (this.editValue != undefined) {
<kendo-dialog *ngIf="isEditing()" title="{{'Global Configuration' | translate: 'Global Configuration' }}" width="700px" (close)="this.onDone.emit(false)">
    <div class="config-cols">
        <div class="one-col">
            <kendo-label text="{{'Baudrate' | translate: 'Baudrate'}}" class="label">
                <kendo-dropdownlist [data]="this.baudRateOptions" [value]="this.editValue.baudrate"
                    [style]="{ width: '150px' }" (valueChange)="this.editValue.baudrate = $event"></kendo-dropdownlist>
            </kendo-label>
            <div>
                <kendo-checkbox #visuGrafieken [(checkedState)]="this.editValue.visuGrafieken"></kendo-checkbox>
                <kendo-label text="{{'Grafiek Optien' | translate: 'Grafiek Opties'}}" [for]="visuGrafieken">
                </kendo-label>
            </div>
            <div>
                <kendo-checkbox #ctdoos [(checkedState)]="this.editValue.ctdoos"></kendo-checkbox>
                <kendo-label text="{{'Contactdozen meting' | translate: 'Contactdozen meting'}}" [for]="ctdoos">
                </kendo-label>
            </div>
            <!-- <div>
                    <kendo-checkbox #pralarm [(checkedState)]="this.editValue.pralarm"></kendo-checkbox>
                    <kendo-label text="Alarmen op printer" [for]="pralarm">
                    </kendo-label>
                </div> -->
            <!-- <div>
                    <kendo-checkbox #nkb [(checkedState)]="this.editValue.nkb"></kendo-checkbox>
                    <kendo-label text="Nieuw keyboard" [for]="nkb">
                    </kendo-label>
                </div> -->
            <!-- <kendo-label text="Kristal" class="label">
                <kendo-dropdownlist [data]="this.kristalOptions" [value]="this.editValue.kristal"
                    [style]="{ width: '150px' }" [valuePrimitive]="true" [valueField]="'index'" [textField]="'label'"
                    (valueChange)="this.editValue.kristal = $event"></kendo-dropdownlist>
            </kendo-label>
            <kendo-label text="Printer" class="label">
                <kendo-dropdownlist [data]="this.printerOptions" [value]="this.editValue.srtPrn"
                    [style]="{ width: '150px' }" [valuePrimitive]="true" [valueField]="'index'" [textField]="'label'"
                    (valueChange)="this.editValue.srtPrn = $event"></kendo-dropdownlist>
            </kendo-label> -->
            <!-- <div>
                    <kendo-checkbox #overzPCLCD [(checkedState)]="this.editValue.overzPCLCD"></kendo-checkbox>
                    <kendo-label text="Oberzichten via PC/LCD" [for]="overzPCLCD">
                    </kendo-label>
                </div> -->
            <div>
                <kendo-checkbox #weermast [(checkedState)]="this.editValue.weermast"></kendo-checkbox>
                <kendo-label text="{{'Weermast aanwezig' | translate: 'Weermast aanwezig'}}" [for]="weermast">
                </kendo-label>
            </div>
            <!-- <div>
                    <kendo-checkbox #nieuwVideo [(checkedState)]="this.editValue.nieuwVideo"></kendo-checkbox>
                    <kendo-label text="Nieuwe video print" [for]="nieuwVideo">
                    </kendo-label>
                </div>
                <div>
                    <kendo-checkbox #compress [(checkedState)]="this.editValue.compress"></kendo-checkbox>
                    <kendo-label text="Compress kop" [for]="compress">
                    </kendo-label>
                </div> -->
            <kendo-label text="{{'Computer Type' | translate: 'Computer Type'}}" class="label">
                <kendo-dropdownlist [data]="this.computerTypeOptions" [value]="this.editValue.compType"
                    [style]="{ width: '150px' }" [valuePrimitive]="true" [valueField]="'index'" [textField]="'label'"
                    (valueChange)="this.editValue.compType = $event"></kendo-dropdownlist>
            </kendo-label>
            <kendo-label text="{{'T.E. Instalatie:' | translate: 'T.E. Instalatie'}}" class="label">
                <kendo-dropdownlist [data]="this.totenerOptions" [value]="this.editValue.totener"
                    [style]="{ width: '150px' }" [valuePrimitive]="true" [valueField]="'index'" [textField]="'label'"
                    (valueChange)="this.editValue.totener = $event"></kendo-dropdownlist>
            </kendo-label>
            <kendo-label text="{{'PC Bedieningen' | translate: 'PC Bedieningen'}}" class="label">
                <kendo-numerictextbox [(value)]="this.editValue.noBedieningen" [min]="0" format="n0"
                    [style]="{ width: '100px' }"></kendo-numerictextbox>
            </kendo-label>
            <kendo-label text="{{'Gekoppeld klant no.' | translate: 'Gekoppeld klant no.'}}" class="label">
                <kendo-textbox [style]="{ width: '150px' }" [(value)]="this.editValue.gekoppeldKlantno" />
            </kendo-label>
            <!-- <div>
                <kendo-label text="Printer tekst">
                    <kendo-textbox [(value)]="this.editValue.comTxt" />
                </kendo-label>
            </div> -->
        </div>
        <div class="one-col">
            <kendo-label text="{{'Klimaat Versie' | translate: 'Klimaat Versie'}}" class="label">
                <kendo-textbox [(value)]="this.editValue.klimaatVersion" [style]="{ width: '200px' }"></kendo-textbox>
            </kendo-label>
            <kendo-label text="{{'Station' | translate: 'Station'}}" class="label">
                <kendo-numerictextbox [(value)]="this.editValue.station" [min]="0" format="n0"
                    [style]="{ width: '100px' }"></kendo-numerictextbox>
            </kendo-label>
            <kendo-label text="{{'Cyclische Peak Shaving' | translate: 'Cyclische Peak Shaving'}}" class="label">
                <kendo-numerictextbox [(value)]="this.editValue.cyclPeak" [min]="0" format="n0"
                    [style]="{ width: '100px' }"></kendo-numerictextbox>
            </kendo-label>
            <!-- <div>
                    <kendo-label text="Tussenstop zone 1 witlof">
                        <kendo-numerictextbox [(value)]="this.editValue.nszone[0]" [min]="0" format="n0"
                            [style]="{ width: '100px' }"></kendo-numerictextbox>
                    </kendo-label>
                </div>
                <div>
                    <kendo-label text="Tussenstop zone 2 witlof">
                        <kendo-numerictextbox [(value)]="this.editValue.nszone[1]" [min]="0" format="n0"
                            [style]="{ width: '100px' }"></kendo-numerictextbox>
                    </kendo-label>
                </div>
                <div>
                    <kendo-label text="Tussenstop zone 3 witlof">
                        <kendo-numerictextbox [(value)]="this.editValue.nszone[2]" [min]="0" format="n0"
                            [style]="{ width: '100px' }"></kendo-numerictextbox>
                    </kendo-label>
                </div>
                <div>
                    <kendo-label text="Tussenstop zone 4 witlof">
                        <kendo-numerictextbox [(value)]="this.editValue.nszone[3]" [min]="0" format="n0"
                            [style]="{ width: '100px' }"></kendo-numerictextbox>
                    </kendo-label>
                </div> -->
            <!-- <div>
                    <kendo-label text="Luchtdruk storing">
                        <kendo-numerictextbox [(value)]="this.editValue.luchtdruk" [min]="0" format="n0"
                            [style]="{ width: '100px' }"></kendo-numerictextbox>
                    </kendo-label>
                </div> -->
            <kendo-label text="{{'Update nr door SERCOM' | translate: 'Update nr door SERCOM'}}" class="label">
                <kendo-numerictextbox [(value)]="this.editValue.updatenr" [min]="0" format="n0" [readonly]="true"
                    [style]="{ width: '100px' }"></kendo-numerictextbox>
            </kendo-label>

            <div>
                <kendo-checkbox #peakShaveInZones [(checkedState)]="this.editValue.peakShaveInZones"></kendo-checkbox>
                <kendo-label text="{{'Peak Shave in zones' | translate: 'Peak Shave in zones'}}" [for]="peakShaveInZones">
                </kendo-label>
            </div>

            <div>
                <kendo-checkbox #noVerhoogKetelSp [(checkedState)]="this.editValue.noVerhoogKetelSp"></kendo-checkbox>
                <kendo-label text="{{'Geen verhoging ketelsetpoint' | translate: 'Geen verhoging ketelsetpoint'}}" [for]="noVerhoogKetelSp">
                </kendo-label>
            </div>

            <div>
                <kendo-checkbox #windVaanRefSpan7V [(checkedState)]="this.editValue.windVaanRefSpan7V"></kendo-checkbox>
                <kendo-label text="{{'Windvaan ref. spanning 7.2V' | translate: 'Windvaan ref. spanning 7.2V'}}" [for]="windVaanRefSpan7V">
                </kendo-label>
            </div>
            <div>
                <kendo-checkbox #sc9x0_FastLink [(checkedState)]="this.editValue.sc9x0_FastLink"></kendo-checkbox>
                <kendo-label text="{{'SC9x0 / FastLink' | translate: 'SC9x0 / FastLink'}}" [for]="sc9x0_FastLink">
                </kendo-label>
            </div>
            <div>
                <kendo-checkbox #gasMeting2Apart [(checkedState)]="this.editValue.gasMeting2Apart"></kendo-checkbox>
                <kendo-label text="{{'Gasmeting 2 apart' | translate: 'Gasmeting 2 apart'}}" [for]="gasMeting2Apart">
                </kendo-label>
            </div>
            <div>
                <kendo-checkbox #digWindsnelhOpDI1 [(checkedState)]="this.editValue.digWindsnelhOpDI1"></kendo-checkbox>
                <kendo-label text="{{'Digitale windsnelheidmeting op DI 1' | translate: 'Digitale windsnelheidmeting op DI 1'}}" [for]="digWindsnelhOpDI1">
                </kendo-label>
            </div>
            <!-- <div>
                    <kendo-checkbox #branderOpMinTemp [(checkedState)]="this.editValue.branderOpMinTemp"></kendo-checkbox>
                    <kendo-label text="Brander op minimum temperatuur houden" [for]="branderOpMinTemp">
                    </kendo-label>
                </div> -->
            <!-- <div>
                    <kendo-checkbox #dauwpuntBegrenzing [(checkedState)]="this.editValue.dauwpuntBegrenzing"></kendo-checkbox>
                    <kendo-label text="Dauwpunt begrenzing" [for]="dauwpuntBegrenzing">
                    </kendo-label>
                </div> -->

        </div>
    </div>
    @if (this.jsBridgeService.isDev()) {        
        <translation-editor />
    }
    <kendo-dialog-actions>
        <button kendoButton (click)="this.onDone.emit(false)">{{'Cancel' | translate: 'Cancel'}}</button>
        <button kendoButton (click)="onSave()" themeColor="primary">
            {{'Save' | translate: 'Save'}}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>
}